import Banner 		from '../../components/Banner';
import AfterBanner 	from '../../components/AfterBanner';
import Content 		from './Content';
import '../../../assets/nexatel.css';
import Interested2 from '../../components/Interested2';
import React from 'react'
import { NexatelPage, CreateToken, detectDevice, AboutUs } from '../../../controller/index'
import { useSelector } from 'react-redux'
import { Shimmer } from 'react-shimmer';
import { Helmet } from 'react-helmet';

let isCompatible = detectDevice()

function Nexatel() {
	const [result, setResult] = React.useState(null)
	const [interested, setInterested] = React.useState(null)
	const langs = useSelector(state => state.langs);
	const [statusLang] = React.useState(langs[0].idLang)

	let langCondition = (statusLang !== langs[0].idLang)

	React.useEffect(() => {
		CreateToken().then((data) => {
			AboutUs().then((data) => {
				setInterested(data.response[0])
			})
			NexatelPage().then((data) => {
				setResult(data.response[0]) 
			}).catch((err) => {
				setResult(err)
			})
		})
	}, [langCondition]);

	let eBanner 			= <h1 className="banner-text fw-bold"><span>Nexatel</span></h1>;
	let eTitle				= "Nexatel"
	let sBanner_desc  		= result !== null ? result.tentang_1.split('|')[1].replaceAll('<br/>', '') : <Shimmer width={20} height={4} />
	let sAfterBanner_title 	= result !== null ? result.tentang_2.replaceAll('<br/>', '') : <Shimmer width={20} height={4} />
	let sAfterBanner_desc 	= result !== null ? result.tentang_3.replaceAll('<br/>', '') : <Shimmer width={20} height={4} />
	let mainBannerPage		= isCompatible ? "https://minio.nexa.net.id/nexa/banner_nexatel.webp" : "https://minio.nexa.net.id/nexa/banner_nexatel.jpeg"

	return (
		<div>

			<Helmet>
				<title>{`Nexa - ${eTitle}`}</title>
				<meta property="og:title" content={eTitle} ></meta>
				<meta property="og:site_name" content="Nexa"></meta>
				<meta property="og:url" content={window.location.href}></meta>
				<meta property="og:description" content={sAfterBanner_title}></meta>
				<meta name="description" content={sAfterBanner_title}></meta>
				<meta property="og:type" content="product"></meta>
				<meta property="og:image" content={mainBannerPage}></meta>
			</Helmet>
			{/* <Banner title={eBanner} desc={sBanner_desc} url_image={mainBannerPage} /> */}
			<Banner title={eBanner} url_image={mainBannerPage} />
			
			<AfterBanner title={sAfterBanner_title} desc={sAfterBanner_desc} />
			<Content storeData={result} />
			{ (interested == null) && <Interested2 storeData={null} /> }
			{ (interested !== null) && <Interested2 storeData={interested} /> }
		</div>
		);
}

export default Nexatel;